import {$window, $body} from '../../../Constants';
import SwiperSlider from '../../../Elements/SwiperSlider';

/**
 * Teaser Slider
 */
const TeaserSlider = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		TEASER_SLIDER: '.ig-teasers-type-3.swiper-container',
	};

	/**
	 * Class Name
	 *
	 * @var { Object }
	 */
	const ClassName = {
		CAN_CENTER: 'can-center'
	};

	/**
	 * Teaser Slider
	 *
	 * @class
	 * @augments SwiperSlider
	 */
	class TeaserSlider extends SwiperSlider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.setOptions({
				spaceBetween: !this.$element.hasClass('collapse') ? 30 : 0,
				slidesPerView: this.$element.data('cols-large'),
				grabCursor: true,
				pagination: {
					el: `${Selector.TEASER_SLIDER} ${this.constructor.Selector.PAGINATION}`,
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				},
				breakpoints: {
					1600: {
						slidesPerView: this.$element.data('cols-large')
					},
					1200: {
						slidesPerView: this.$element.data('cols-large') > 4 ? this.$element.data('cols-large') - 2 : this.$element.data('cols-large') - 1
					},
					1023: {
						slidesPerView: this.$element.data('cols-medium')
					},
					550: {
						slidesPerView: 1
					}
				}
			});

			this._initialize();
			this._bindHandlers();
			this._handleCentering();
		}

		/**
		 * Binds the event handlers to the elements
		 *
		 * @return void
		 */
		_bindHandlers() {
			$window.on('resize', () => {
				this._handleCentering();
			});
		}

		/**
		 * Handles the centering by adding or removing the css class
		 *
		 * @return void
		 */
		_handleCentering() {
			this.$element.toggleClass(ClassName.CAN_CENTER, this.length < this.slider.params.slidesPerView);
		}
	}

	return TeaserSlider._getElements($body.find(Selector.TEASER_SLIDER), TeaserSlider);
})();

export default TeaserSlider;
